import axioPath from '../../../api/axioPath';
import { showAppLoader, hideAppLoader } from '../app';

export const fetchGlobalFeeDataAPI = () => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.get('/user/v2/dynamic_fee/get_universal_fee', {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const addUpdateGlobalFeeDataAPI = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.post('/user/v2/dynamic_fee/add_update_universal_fee', data, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const fetchSupplierTermsListDataAPI = (data, loadingType) => (dispatch) => {
  if (loadingType !== 'noLoader') dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.post('/user/v2/dynamic_fee/get_supplier_fee', data, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const fetchSupplierCompanyNamesAPI = () => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.get('/user/v2/get_main_independent_locations', {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const fetchSelectedCompanyDetailsAPI = (id) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.get('/user/v2/dynamic_fee/get_supplier_by_location/' + id, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const addUpdateSupplierTermsAPI = (data) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.post('/user/v2/dynamic_fee/add_update_supplier_fee', data, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const deleteSupplierTermsAPI = (id) => (dispatch) => {
  dispatch(showAppLoader());
  const token = localStorage.getItem("token")
  return axioPath.delete('/user/v2/dynamic_fee/delete_supplier_fee/' + id, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};